import { useIsMobile } from 'apps/exegesis/styles/themes';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';
import DateDisplay from '../DateDisplay';
import { useMenu } from './NotesLayout';

const SidebarNote = (props: {
  noteId: string;
  title: string | null;
  creationDate: Date;
  lastEditedDate: Date;
  public: boolean;
}) => {
  const router = useRouter();
  const setMenuOpen = useMenu((state) => state.setMenuOpen);
  let noteId = '';
  if (router.query.slug) {
    noteId = router.query.slug[0];
  }

  const isMobile = useIsMobile();

  return (
    <div
      onClick={() => {
        if (isMobile) {
          setMenuOpen(false);
        }
        router.push(
          props.public
            ? '/post/' + props.noteId
            : '/notes/editor/' + props.noteId
        );
      }}
    >
      <SidebarNoteContainer highlight={noteId === props.noteId}>
        <TitleText>{props.title || 'untitled note'}</TitleText>
        <SubtitleText>
          <DateDisplay
            default="lastEdited"
            created={props.creationDate}
            lastEdited={props.lastEditedDate}
          />
        </SubtitleText>
      </SidebarNoteContainer>
    </div>
  );
};

const SidebarNoteContainer = styled.div<{ highlight: boolean }>`
  padding: 5px 5px 5px 10px;
  background-color: ${(props) =>
    props.highlight ? props.theme.colors.main.medium : 'none'};
  :hover {
    background-color: ${(props) =>
      props.highlight
        ? props.theme.colors.main.medium
        : props.theme.colors.main.light};
  }
`;

const TitleText = styled.p`
  padding: 0px 0px 0px 10px;
  margin: 0px;
  font-size: 1rem;
`;
const SubtitleText = styled.div`
  padding: 0px 0px 0px 10px;
  margin: 0px;
  font-style: italic;
  font-size: 0.75rem;
`;

export default SidebarNote;
